<template>
  <v-card width="250">
    <ul class="sentiment-list">
      <li
        v-if="sentiment !== undefined"
        class="sentiment-list__item"
        @click="clearSelection"
      >
        <div>{{ $t("message.sentiment.clearSelection") }}</div>
        <v-icon>mdi-close</v-icon>
      </li>
      <li
        v-for="item in sentimentOptions"
        :key="item.id"
        class="sentiment-list__item"
        :class="{
          'sentiment-list__item--active': sentiment === item.value
        }"
        @click="setSentiment(item.value)"
      >
        <div>{{ item.label }}</div>
        <component :is="item.icon" />
      </li>
    </ul>
  </v-card>
</template>

<script>
import cuid from "cuid";
import PositiveIcon from "@/components/ui/Icons/sentiment/PositiveIcon.vue";
import NegativeIcon from "@/components/ui/Icons/sentiment/NegativeIcon.vue";
import UndefinedIcon from "@/components/ui/Icons/sentiment/UndefinedIcon.vue";
import NeutralIcon from "@/components/ui/Icons/sentiment/NeutralIcon.vue";

import { SENTIMENT_TYPES, SENTIMENT_ICON_COMPONENTS } from "@/enums/sentiment";

export default {
  name: "TagsManagerListSentimentSelectorDropdown",
  components: {
    PositiveIcon,
    NegativeIcon,
    UndefinedIcon,
    NeutralIcon
  },
  props: {
    sentiment: {
      type: [Number, null]
    }
  },
  data() {
    return {
      sentimentOptions: [
        {
          id: cuid(),
          label: this.$t("message.sentiment.markAsPositive"),
          value: SENTIMENT_TYPES.POSITIVE,
          icon: SENTIMENT_ICON_COMPONENTS[SENTIMENT_TYPES.POSITIVE]
        },
        {
          id: cuid(),
          label: this.$t("message.sentiment.markAsNeutral"),
          value: SENTIMENT_TYPES.NEUTRAL,
          icon: SENTIMENT_ICON_COMPONENTS[SENTIMENT_TYPES.NEUTRAL]
        },
        {
          id: cuid(),
          label: this.$t("message.sentiment.markAsNegative"),
          value: SENTIMENT_TYPES.NEGATIVE,
          icon: SENTIMENT_ICON_COMPONENTS[SENTIMENT_TYPES.NEGATIVE]
        },
        {
          id: cuid(),
          label: this.$t("message.sentiment.unknown"),
          value: SENTIMENT_TYPES.UNKNOWN,
          icon: SENTIMENT_ICON_COMPONENTS[SENTIMENT_TYPES.UNKNOWN]
        }
      ]
    };
  },
  methods: {
    setSentiment(sentiment) {
      this.$emit("change-sentiment", sentiment);
    },
    clearSelection() {
      this.$emit("clear-selection");
    }
  }
};
</script>

<style lang="scss" scoped>
.sentiment-list {
  padding: 0;
  margin: 0;

  &__item {
    list-style: none;
    @include font-size(14px);
    padding: $spacing * 1.5 $spacing * 2;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: $spacing;
    justify-content: space-between;

    & + & {
      border-top: 1px solid $gray-300;
    }

    &--active {
      font-weight: bold;
      color: $primary;
    }

    &:hover {
      background: $gray-200;
    }
  }
}
</style>
